var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table_block"},[_c('Table',{attrs:{"loading":_vm.loading,"border":"","stripe":"","columns":_vm.columns,"data":_vm.table.data,"size":"small","height":_vm.table.height,"disabled-hover":"","highlight-row":""},on:{"on-selection-change":_vm.selectionChange,"on-row-click":_vm.onRowClick}}),_c('RouterModel',{ref:"routerModal"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }